export default function FacebookIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M23.9999 12.5729C23.9999 5.90468 18.627 0.499054 11.9992 0.499054C5.37143 0.499054 -0.00146484 5.90468 -0.00146484 12.5729C-0.00146484 18.5993 4.38702 23.5942 10.1241 24.5V16.0629H7.07708V12.5729H10.1241V9.91285C10.1241 6.88685 11.9158 5.21539 14.657 5.21539C15.9699 5.21539 17.3433 5.4512 17.3433 5.4512V8.42249H15.83C14.3393 8.42249 13.8743 9.35319 13.8743 10.308V12.5729H17.2027L16.6706 16.0629H13.8743V24.5C19.6115 23.5942 23.9999 18.5993 23.9999 12.5729Z"
        fill="#8897AE"
      />
    </svg>
  );
}
